export const UrlModuleMap = {
    'real_estate': 'buyHouse',
    'education_fund': 'educationFund'
}

export const ModuleScenarioMap = {
    'buyHouse': 'real_estate',
    'educationFund': 'education_fund'
}